
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHarbourBerthing as ObiHarbourBerthingElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-harbour-berthing.js';
 
 
 

 
 export const ObiHarbourBerthing = createComponent({
   react: React,
   tagName: 'obi-harbour-berthing',
   elementClass: ObiHarbourBerthingElement,
   events: {
     
   }
  });
 
 